const CARD_ITEMS = [
  {
    id: 1,
    title: '顶流小生深夜密会神秘女子，酒店同框照曝光',
    tag: '娱乐圈',
    summary: '近日有网友拍到某当红男星深夜与一神秘女子现身酒店大堂，两人举止亲密引发恋情猜测。粉丝后援会已紧急发声回应。',
    image: 'https://readdy.ai/api/search-image?query=Warm%20editorial%20photography%2C%20abstract%20celebrity%20dating%20rumor%20theme%2C%20soft%20coral%20and%20cream%20lighting%2C%20clean%20minimalist%20background%2C%20suggesting%20entertainment%20gossip%2C%20magazine%20quality%2C%20warm%20ambient%20atmosphere%2C%20professional%20photography%2C%20no%20text%20visible&width=600&height=400&seq=cards-deep-01&orientation=landscape',
  },
  {
    id: 2,
    title: '知名女星被爆税务问题，工作室火速发布律师函',
    tag: '娱乐圈',
    summary: '某一线女星近日被匿名爆料涉及大额税务问题，相关话题迅速登上热搜。其工作室在事发两小时内发布正式律师函予以否认。',
    image: 'https://readdy.ai/api/search-image?query=Editorial%20photography%20style%2C%20warm%20amber%20lighting%2C%20abstract%20legal%20document%20theme%2C%20clean%20minimalist%20background%2C%20suggesting%20celebrity%20legal%20controversy%2C%20magazine%20quality%2C%20professional%20composition%2C%20soft%20shadows%2C%20warm%20tones%2C%20no%20text&width=600&height=400&seq=cards-deep-02&orientation=landscape',
  },
  {
    id: 3,
    title: '头部主播直播间口误翻车，品牌方连夜解约索赔',
    tag: '网红圈',
    summary: '某千万粉丝头部带货主播在直播中因不当言论引发舆论风暴，多个合作品牌连夜发布解约声明，事件仍在持续发酵中。',
    image: 'https://readdy.ai/api/search-image?query=Warm%20editorial%20photography%2C%20abstract%20live%20streaming%20studio%20theme%2C%20soft%20coral%20accents%2C%20clean%20minimalist%20background%2C%20suggesting%20influencer%20controversy%2C%20magazine%20quality%2C%20warm%20ambient%20lighting%2C%20professional%20photography%2C%20no%20text%20visible&width=600&height=400&seq=cards-deep-03&orientation=landscape',
  },
  {
    id: 4,
    title: '选秀节目导演组内讧，淘汰名单遭提前泄露',
    tag: '综艺',
    summary: '某热门选秀节目最新一期淘汰名单在录制后遭内部人员泄露，网友发现名单与现场观众爆料高度吻合，节目组尚未回应。',
    image: 'https://readdy.ai/api/search-image?query=Editorial%20photography%2C%20warm%20amber%20lighting%2C%20abstract%20talent%20show%20production%20theme%2C%20clean%20minimalist%20background%2C%20suggesting%20reality%20TV%20drama%2C%20magazine%20quality%2C%20professional%20photography%2C%20soft%20shadows%2C%20warm%20tones%2C%20no%20text&width=600&height=400&seq=cards-deep-04&orientation=landscape',
  },
  {
    id: 5,
    title: '电竞豪门内部矛盾曝光，明星选手恐将转会',
    tag: '电竞圈',
    summary: '某知名电竞俱乐部内部管理问题近日被多位业内人士爆料，核心选手与教练组矛盾公开化，转会市场或将迎来大地震。',
    image: 'https://readdy.ai/api/search-image?query=Warm%20editorial%20photography%2C%20abstract%20esports%20arena%20theme%2C%20soft%20coral%20and%20cream%20lighting%2C%20clean%20minimalist%20background%2C%20suggesting%20esports%20team%20drama%2C%20magazine%20quality%2C%20warm%20ambient%20atmosphere%2C%20professional%20photography%2C%20no%20text&width=600&height=400&seq=cards-deep-05&orientation=landscape',
  },
  {
    id: 6,
    title: '影视剧拍摄现场冲突，男女主角被爆片场零交流',
    tag: '影视圈',
    summary: '某古装大剧拍摄现场近日传出男女主角关系不和的爆料，据剧组工作人员透露两人已经连续多日在片场零交流，拍摄进度受影响。',
    image: 'https://readdy.ai/api/search-image?query=Editorial%20photography%20style%2C%20warm%20amber%20lighting%2C%20abstract%20film%20production%20set%20theme%2C%20clean%20minimalist%20background%2C%20suggesting%20movie%20set%20drama%2C%20magazine%20quality%2C%20professional%20composition%2C%20warm%20tones%2C%20no%20text&width=600&height=400&seq=cards-deep-06&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="section-container">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10">
          <div>
            <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-accent-100 text-accent-700 mb-3">
              深度爆料
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              独家深度吃瓜
            </h2>
          </div>
          <a
            href="#updates"
            className="inline-flex items-center gap-1 text-sm text-accent-600 hover:text-accent-700 font-medium whitespace-nowrap cursor-pointer"
          >
            全部爆料 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {CARD_ITEMS.map((item) => (
            <article
              key={item.id}
              className="group bg-background-50 rounded-xl border border-background-200/60 overflow-hidden hover:border-background-300/80 transition-all cursor-pointer"
            >
              <div className="aspect-[3/2] overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  width="600"
                  height="400"
                />
              </div>
              <div className="p-5">
                <span className="inline-block px-2.5 py-1 rounded-md bg-accent-100 text-accent-700 text-xs font-medium mb-3">
                  {item.tag}
                </span>
                <h3 className="text-base font-heading font-bold text-foreground-950 mb-2 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3">
                  {item.summary}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}